import React from "react";
import { Gavel, Database, Users, LogOut, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";

interface HeaderProps {
  editaisCount: number;
  onOpenEquipe: () => void;
}

export const Header: React.FC<HeaderProps> = ({ editaisCount, onOpenEquipe }) => {
  const { user, logout } = useAuth();

  return (
    <header className="header-glass">
      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #2563eb, #3b82f6)",
            padding: "10px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
          }}
        >
          <Gavel size={26} color="#ffffff" />
        </div>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h1 className="brand-title" style={{ margin: 0 }}>Right Bid</h1>
            <span
              className="badge"
              style={{
                background: "rgba(16, 185, 129, 0.15)",
                color: "#34d399",
                border: "1px solid rgba(16, 185, 129, 0.3)",
                fontSize: "0.7rem",
                padding: "2px 8px",
              }}
            >
              Ambiente Privado
            </span>
          </div>
          <p style={{ fontSize: "0.8rem", color: "var(--text-muted)", margin: "4px 0 0 0" }}>
            Inteligência Analítica & Decisão de Lances da Receita Federal
          </p>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
        {/* Contador de Editais */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "var(--bg-card)",
            padding: "8px 12px",
            borderRadius: "10px",
            border: "1px solid var(--border-color)",
            fontSize: "0.825rem",
          }}
        >
          <Database size={15} color="#3b82f6" />
          <span>{editaisCount} Editais</span>
        </div>

        {/* Botão de Equipe (Apenas ADMIN) */}
        {user?.role === "ADMIN" && (
          <button
            onClick={onOpenEquipe}
            className="btn btn-outline"
            style={{ fontSize: "0.825rem", padding: "8px 12px", display: "flex", alignItems: "center", gap: "6px" }}
          >
            <Users size={15} color="#f59e0b" />
            <span>Gerenciar Equipe</span>
          </button>
        )}

        {/* Perfil do Usuário e Logout */}
        {user && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              background: "var(--bg-secondary)",
              border: "1px solid var(--border-color)",
              padding: "6px 12px",
              borderRadius: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <User size={16} color="#38bdf8" />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "0.825rem", fontWeight: 600, color: "#f8fafc" }}>
                  {user.nome.split(" ")[0]}
                </span>
                <span style={{ fontSize: "0.65rem", color: "var(--text-muted)", textTransform: "uppercase" }}>
                  {user.role}
                </span>
              </div>
            </div>

            <button
              onClick={logout}
              title="Encerrar Sessão"
              style={{
                background: "transparent",
                border: "none",
                color: "#ef4444",
                cursor: "pointer",
                padding: "4px",
                display: "flex",
                alignItems: "center",
                borderRadius: "6px",
              }}
            >
              <LogOut size={16} />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
